var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"id":"nosuitable-contractor-company"}},[_c('list-contractor-company',{attrs:{"filter":"noSuitable"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }